import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import orders from './modules/orders'
import management from './modules/management'




Vue.use(Vuex)

export default new Vuex.Store({
    strict: true,
    modules: {
        auth,
        orders,
        management
    }
})